// extracted by mini-css-extract-plugin
export var active = "_v5-1";
export var circle = "_v5-0";
export var completed = "_v5-2";
export var connector = "_v5-4";
export var connectorCompleted = "_v5-7";
export var connectorSpacer = "_v5-5";
export var iconStrokeOverride = "_v5-8";
export var labelContainer = "_v5-6";
export var pending = "_v5-3";